
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_18wu0_1ie5x_94",
  "box": "awsui_box_18wu0_1ie5x_206",
  "p-variant": "awsui_p-variant_18wu0_1ie5x_206",
  "color-default": "awsui_color-default_18wu0_1ie5x_206",
  "b-variant": "awsui_b-variant_18wu0_1ie5x_206",
  "strong-variant": "awsui_strong-variant_18wu0_1ie5x_206",
  "code-variant": "awsui_code-variant_18wu0_1ie5x_206",
  "pre-variant": "awsui_pre-variant_18wu0_1ie5x_206",
  "samp-variant": "awsui_samp-variant_18wu0_1ie5x_206",
  "h1-variant": "awsui_h1-variant_18wu0_1ie5x_210",
  "h2-variant": "awsui_h2-variant_18wu0_1ie5x_210",
  "h3-variant": "awsui_h3-variant_18wu0_1ie5x_210",
  "h4-variant": "awsui_h4-variant_18wu0_1ie5x_210",
  "h5-variant": "awsui_h5-variant_18wu0_1ie5x_210",
  "small-variant": "awsui_small-variant_18wu0_1ie5x_214",
  "a-variant": "awsui_a-variant_18wu0_1ie5x_218",
  "font-size-default": "awsui_font-size-default_18wu0_1ie5x_222",
  "font-weight-default": "awsui_font-weight-default_18wu0_1ie5x_262",
  "key-label-variant": "awsui_key-label-variant_18wu0_1ie5x_302",
  "value-large-variant": "awsui_value-large-variant_18wu0_1ie5x_309",
  "font-weight-heavy": "awsui_font-weight-heavy_18wu0_1ie5x_316",
  "color-inverted": "awsui_color-inverted_18wu0_1ie5x_321",
  "color-text-label": "awsui_color-text-label_18wu0_1ie5x_324",
  "color-text-body-secondary": "awsui_color-text-body-secondary_18wu0_1ie5x_327",
  "color-text-status-error": "awsui_color-text-status-error_18wu0_1ie5x_330",
  "color-text-status-success": "awsui_color-text-status-success_18wu0_1ie5x_333",
  "color-text-status-info": "awsui_color-text-status-info_18wu0_1ie5x_336",
  "color-text-status-inactive": "awsui_color-text-status-inactive_18wu0_1ie5x_339",
  "color-inherit": "awsui_color-inherit_18wu0_1ie5x_342",
  "font-size-body-s": "awsui_font-size-body-s_18wu0_1ie5x_345",
  "font-size-body-m": "awsui_font-size-body-m_18wu0_1ie5x_350",
  "font-size-heading-xs": "awsui_font-size-heading-xs_18wu0_1ie5x_354",
  "font-size-heading-s": "awsui_font-size-heading-s_18wu0_1ie5x_358",
  "font-size-heading-m": "awsui_font-size-heading-m_18wu0_1ie5x_363",
  "font-size-heading-l": "awsui_font-size-heading-l_18wu0_1ie5x_368",
  "font-size-heading-xl": "awsui_font-size-heading-xl_18wu0_1ie5x_373",
  "font-size-display-l": "awsui_font-size-display-l_18wu0_1ie5x_378",
  "font-weight-light": "awsui_font-weight-light_18wu0_1ie5x_383",
  "font-weight-normal": "awsui_font-weight-normal_18wu0_1ie5x_386",
  "font-weight-bold": "awsui_font-weight-bold_18wu0_1ie5x_389",
  "t-left": "awsui_t-left_18wu0_1ie5x_396",
  "t-right": "awsui_t-right_18wu0_1ie5x_400",
  "t-center": "awsui_t-center_18wu0_1ie5x_404",
  "p-n": "awsui_p-n_18wu0_1ie5x_505",
  "p-top-n": "awsui_p-top-n_18wu0_1ie5x_509",
  "p-vertical-n": "awsui_p-vertical-n_18wu0_1ie5x_510",
  "p-right-n": "awsui_p-right-n_18wu0_1ie5x_514",
  "p-horizontal-n": "awsui_p-horizontal-n_18wu0_1ie5x_515",
  "p-bottom-n": "awsui_p-bottom-n_18wu0_1ie5x_519",
  "p-left-n": "awsui_p-left-n_18wu0_1ie5x_524",
  "p-xxxs": "awsui_p-xxxs_18wu0_1ie5x_529",
  "p-top-xxxs": "awsui_p-top-xxxs_18wu0_1ie5x_533",
  "p-vertical-xxxs": "awsui_p-vertical-xxxs_18wu0_1ie5x_534",
  "p-right-xxxs": "awsui_p-right-xxxs_18wu0_1ie5x_538",
  "p-horizontal-xxxs": "awsui_p-horizontal-xxxs_18wu0_1ie5x_539",
  "p-bottom-xxxs": "awsui_p-bottom-xxxs_18wu0_1ie5x_543",
  "p-left-xxxs": "awsui_p-left-xxxs_18wu0_1ie5x_548",
  "p-xxs": "awsui_p-xxs_18wu0_1ie5x_553",
  "p-top-xxs": "awsui_p-top-xxs_18wu0_1ie5x_557",
  "p-vertical-xxs": "awsui_p-vertical-xxs_18wu0_1ie5x_558",
  "p-right-xxs": "awsui_p-right-xxs_18wu0_1ie5x_562",
  "p-horizontal-xxs": "awsui_p-horizontal-xxs_18wu0_1ie5x_563",
  "p-bottom-xxs": "awsui_p-bottom-xxs_18wu0_1ie5x_567",
  "p-left-xxs": "awsui_p-left-xxs_18wu0_1ie5x_572",
  "p-xs": "awsui_p-xs_18wu0_1ie5x_577",
  "p-top-xs": "awsui_p-top-xs_18wu0_1ie5x_581",
  "p-vertical-xs": "awsui_p-vertical-xs_18wu0_1ie5x_582",
  "p-right-xs": "awsui_p-right-xs_18wu0_1ie5x_586",
  "p-horizontal-xs": "awsui_p-horizontal-xs_18wu0_1ie5x_587",
  "p-bottom-xs": "awsui_p-bottom-xs_18wu0_1ie5x_591",
  "p-left-xs": "awsui_p-left-xs_18wu0_1ie5x_596",
  "p-s": "awsui_p-s_18wu0_1ie5x_601",
  "p-top-s": "awsui_p-top-s_18wu0_1ie5x_605",
  "p-vertical-s": "awsui_p-vertical-s_18wu0_1ie5x_606",
  "p-right-s": "awsui_p-right-s_18wu0_1ie5x_610",
  "p-horizontal-s": "awsui_p-horizontal-s_18wu0_1ie5x_611",
  "p-bottom-s": "awsui_p-bottom-s_18wu0_1ie5x_615",
  "p-left-s": "awsui_p-left-s_18wu0_1ie5x_620",
  "p-m": "awsui_p-m_18wu0_1ie5x_625",
  "p-top-m": "awsui_p-top-m_18wu0_1ie5x_629",
  "p-vertical-m": "awsui_p-vertical-m_18wu0_1ie5x_630",
  "p-right-m": "awsui_p-right-m_18wu0_1ie5x_634",
  "p-horizontal-m": "awsui_p-horizontal-m_18wu0_1ie5x_635",
  "p-bottom-m": "awsui_p-bottom-m_18wu0_1ie5x_639",
  "p-left-m": "awsui_p-left-m_18wu0_1ie5x_644",
  "p-l": "awsui_p-l_18wu0_1ie5x_524",
  "p-top-l": "awsui_p-top-l_18wu0_1ie5x_653",
  "p-vertical-l": "awsui_p-vertical-l_18wu0_1ie5x_654",
  "p-right-l": "awsui_p-right-l_18wu0_1ie5x_658",
  "p-horizontal-l": "awsui_p-horizontal-l_18wu0_1ie5x_659",
  "p-bottom-l": "awsui_p-bottom-l_18wu0_1ie5x_663",
  "p-left-l": "awsui_p-left-l_18wu0_1ie5x_668",
  "p-xl": "awsui_p-xl_18wu0_1ie5x_673",
  "p-top-xl": "awsui_p-top-xl_18wu0_1ie5x_677",
  "p-vertical-xl": "awsui_p-vertical-xl_18wu0_1ie5x_678",
  "p-right-xl": "awsui_p-right-xl_18wu0_1ie5x_682",
  "p-horizontal-xl": "awsui_p-horizontal-xl_18wu0_1ie5x_683",
  "p-bottom-xl": "awsui_p-bottom-xl_18wu0_1ie5x_687",
  "p-left-xl": "awsui_p-left-xl_18wu0_1ie5x_692",
  "p-xxl": "awsui_p-xxl_18wu0_1ie5x_697",
  "p-top-xxl": "awsui_p-top-xxl_18wu0_1ie5x_701",
  "p-vertical-xxl": "awsui_p-vertical-xxl_18wu0_1ie5x_702",
  "p-right-xxl": "awsui_p-right-xxl_18wu0_1ie5x_706",
  "p-horizontal-xxl": "awsui_p-horizontal-xxl_18wu0_1ie5x_707",
  "p-bottom-xxl": "awsui_p-bottom-xxl_18wu0_1ie5x_711",
  "p-left-xxl": "awsui_p-left-xxl_18wu0_1ie5x_716",
  "p-xxxl": "awsui_p-xxxl_18wu0_1ie5x_721",
  "p-top-xxxl": "awsui_p-top-xxxl_18wu0_1ie5x_725",
  "p-vertical-xxxl": "awsui_p-vertical-xxxl_18wu0_1ie5x_726",
  "p-right-xxxl": "awsui_p-right-xxxl_18wu0_1ie5x_730",
  "p-horizontal-xxxl": "awsui_p-horizontal-xxxl_18wu0_1ie5x_731",
  "p-bottom-xxxl": "awsui_p-bottom-xxxl_18wu0_1ie5x_735",
  "p-left-xxxl": "awsui_p-left-xxxl_18wu0_1ie5x_740",
  "m-n": "awsui_m-n_18wu0_1ie5x_745",
  "m-top-n": "awsui_m-top-n_18wu0_1ie5x_749",
  "m-vertical-n": "awsui_m-vertical-n_18wu0_1ie5x_750",
  "m-right-n": "awsui_m-right-n_18wu0_1ie5x_754",
  "m-horizontal-n": "awsui_m-horizontal-n_18wu0_1ie5x_755",
  "m-bottom-n": "awsui_m-bottom-n_18wu0_1ie5x_759",
  "m-left-n": "awsui_m-left-n_18wu0_1ie5x_764",
  "m-xxxs": "awsui_m-xxxs_18wu0_1ie5x_769",
  "m-top-xxxs": "awsui_m-top-xxxs_18wu0_1ie5x_773",
  "m-vertical-xxxs": "awsui_m-vertical-xxxs_18wu0_1ie5x_774",
  "m-right-xxxs": "awsui_m-right-xxxs_18wu0_1ie5x_778",
  "m-horizontal-xxxs": "awsui_m-horizontal-xxxs_18wu0_1ie5x_779",
  "m-bottom-xxxs": "awsui_m-bottom-xxxs_18wu0_1ie5x_783",
  "m-left-xxxs": "awsui_m-left-xxxs_18wu0_1ie5x_788",
  "m-xxs": "awsui_m-xxs_18wu0_1ie5x_793",
  "m-top-xxs": "awsui_m-top-xxs_18wu0_1ie5x_797",
  "m-vertical-xxs": "awsui_m-vertical-xxs_18wu0_1ie5x_798",
  "m-right-xxs": "awsui_m-right-xxs_18wu0_1ie5x_802",
  "m-horizontal-xxs": "awsui_m-horizontal-xxs_18wu0_1ie5x_803",
  "m-bottom-xxs": "awsui_m-bottom-xxs_18wu0_1ie5x_807",
  "m-left-xxs": "awsui_m-left-xxs_18wu0_1ie5x_812",
  "m-xs": "awsui_m-xs_18wu0_1ie5x_817",
  "m-top-xs": "awsui_m-top-xs_18wu0_1ie5x_821",
  "m-vertical-xs": "awsui_m-vertical-xs_18wu0_1ie5x_822",
  "m-right-xs": "awsui_m-right-xs_18wu0_1ie5x_826",
  "m-horizontal-xs": "awsui_m-horizontal-xs_18wu0_1ie5x_827",
  "m-bottom-xs": "awsui_m-bottom-xs_18wu0_1ie5x_831",
  "m-left-xs": "awsui_m-left-xs_18wu0_1ie5x_836",
  "m-s": "awsui_m-s_18wu0_1ie5x_841",
  "m-top-s": "awsui_m-top-s_18wu0_1ie5x_845",
  "m-vertical-s": "awsui_m-vertical-s_18wu0_1ie5x_846",
  "m-right-s": "awsui_m-right-s_18wu0_1ie5x_850",
  "m-horizontal-s": "awsui_m-horizontal-s_18wu0_1ie5x_851",
  "m-bottom-s": "awsui_m-bottom-s_18wu0_1ie5x_855",
  "m-left-s": "awsui_m-left-s_18wu0_1ie5x_860",
  "m-m": "awsui_m-m_18wu0_1ie5x_865",
  "m-top-m": "awsui_m-top-m_18wu0_1ie5x_869",
  "m-vertical-m": "awsui_m-vertical-m_18wu0_1ie5x_870",
  "m-right-m": "awsui_m-right-m_18wu0_1ie5x_874",
  "m-horizontal-m": "awsui_m-horizontal-m_18wu0_1ie5x_875",
  "m-bottom-m": "awsui_m-bottom-m_18wu0_1ie5x_879",
  "m-left-m": "awsui_m-left-m_18wu0_1ie5x_884",
  "m-l": "awsui_m-l_18wu0_1ie5x_764",
  "m-top-l": "awsui_m-top-l_18wu0_1ie5x_893",
  "m-vertical-l": "awsui_m-vertical-l_18wu0_1ie5x_894",
  "m-right-l": "awsui_m-right-l_18wu0_1ie5x_898",
  "m-horizontal-l": "awsui_m-horizontal-l_18wu0_1ie5x_899",
  "m-bottom-l": "awsui_m-bottom-l_18wu0_1ie5x_903",
  "m-left-l": "awsui_m-left-l_18wu0_1ie5x_908",
  "m-xl": "awsui_m-xl_18wu0_1ie5x_913",
  "m-top-xl": "awsui_m-top-xl_18wu0_1ie5x_917",
  "m-vertical-xl": "awsui_m-vertical-xl_18wu0_1ie5x_918",
  "m-right-xl": "awsui_m-right-xl_18wu0_1ie5x_922",
  "m-horizontal-xl": "awsui_m-horizontal-xl_18wu0_1ie5x_923",
  "m-bottom-xl": "awsui_m-bottom-xl_18wu0_1ie5x_927",
  "m-left-xl": "awsui_m-left-xl_18wu0_1ie5x_932",
  "m-xxl": "awsui_m-xxl_18wu0_1ie5x_937",
  "m-top-xxl": "awsui_m-top-xxl_18wu0_1ie5x_941",
  "m-vertical-xxl": "awsui_m-vertical-xxl_18wu0_1ie5x_942",
  "m-right-xxl": "awsui_m-right-xxl_18wu0_1ie5x_946",
  "m-horizontal-xxl": "awsui_m-horizontal-xxl_18wu0_1ie5x_947",
  "m-bottom-xxl": "awsui_m-bottom-xxl_18wu0_1ie5x_951",
  "m-left-xxl": "awsui_m-left-xxl_18wu0_1ie5x_956",
  "m-xxxl": "awsui_m-xxxl_18wu0_1ie5x_961",
  "m-top-xxxl": "awsui_m-top-xxxl_18wu0_1ie5x_965",
  "m-vertical-xxxl": "awsui_m-vertical-xxxl_18wu0_1ie5x_966",
  "m-right-xxxl": "awsui_m-right-xxxl_18wu0_1ie5x_970",
  "m-horizontal-xxxl": "awsui_m-horizontal-xxxl_18wu0_1ie5x_971",
  "m-bottom-xxxl": "awsui_m-bottom-xxxl_18wu0_1ie5x_975",
  "m-left-xxxl": "awsui_m-left-xxxl_18wu0_1ie5x_980",
  "d-block": "awsui_d-block_18wu0_1ie5x_985",
  "d-inline": "awsui_d-inline_18wu0_1ie5x_988",
  "d-inline-block": "awsui_d-inline-block_18wu0_1ie5x_991",
  "d-none": "awsui_d-none_18wu0_1ie5x_994",
  "f-left": "awsui_f-left_18wu0_1ie5x_998",
  "f-right": "awsui_f-right_18wu0_1ie5x_1002"
};
  